export default __webpack_public_path__ + "static/media/fl-logo.dbec284f.png";